import React from 'react';
import { IPlatformMeta } from '@invent/shared-types';
import { RemoteModule, generateWidgetData } from '@invent/platform-api';

export const WIDGETS_MAP = new Map();

const generateWidgetModules = (
  name: string,
  widgetId: number,
  platformMeta: IPlatformMeta,
  previewFallback?: IRemoteModuleFallback
) => {
  const data = generateWidgetData(platformMeta)(name, widgetId);
  return {
    component: (props: Record<string, unknown>) => (
      <RemoteModule
        scope={data.scope}
        module={data.component}
        componentProps={props}
        url={data.host}
      />
    ),
    settings: (props: Record<string, unknown>) => (
      <RemoteModule
        scope={data.scope}
        module={data.settings}
        componentProps={props}
        url={data.host}
      />
    ),
    preview: (props: Record<string, unknown>) => (
      <RemoteModule
        scope={data.scope}
        module={data.preview}
        componentProps={props}
        url={data.host}
        fallback={previewFallback}
      />
    )
  };
};

export const produceWidgetComponents = (
  name: string,
  widgetId: number,
  platformMeta: IPlatformMeta,
  previewFallback?: IRemoteModuleFallback
) => {
  // TODO - investigate "previews selector" and whether this fallback is needed
  // probably if all prefixes are good, we won't need it
  if (WIDGETS_MAP.has(name)) {
    return WIDGETS_MAP.get(name);
  }
  const moduleComponents = generateWidgetModules(name, widgetId, platformMeta, previewFallback);
  WIDGETS_MAP.set(name, moduleComponents);
  return moduleComponents;
};
